// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__Hj-ZM","consentGrid":"CookieModal_consentGrid__VyPdY","buttonGrid":"CookieModal_buttonGrid__7x2hI","consentModal":"CookieModal_consentModal__FM2ya"};